import React, { PureComponent } from "react";
import styled from "styled-components";
import rem from "../../utils/rem";

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 10px;
`;

const Input = styled.input`
  opacity: 0;
`;

const Label = styled.label`
  color: rgba(0, 0, 0, 0.54);
  font-size: ${rem(14)};
  line-height: 20px;
  margin-left: 14px;

  &:before {
    content: "";
    top: 0;
    left: 0;
    border: 1px solid #ddd;
    border-radius: 100%;
    position: absolute;
    width: 20px;
    height: 20px;
  }

  &:after {
    content: "";
    top: 5px;
    left: 6px;
    border-radius: 100%;
    position: absolute;
    width: 11px;
    height: 11px;
  }

  ${Input}:checked + &:before {
    background: white;
  }

  ${Input}:checked + &:after {
    background: ${props => props.theme.primary};
  }
`;

class RadioInput extends PureComponent {
  constructor(props) {
    super(props);
    this._handleChange = this._handleChange.bind(this);
  }

  _handleChange(e) {
    const { onChangeHandler, value } = this.props;
    onChangeHandler(value);
  }

  render() {
    const { label, name, selected, value } = this.props;

    return (
      <Wrapper>
        <Input
          type="radio"
          name={name}
          id={`${name}-${value}`}
          checked={selected === value}
          onChange={this._handleChange}
        />
        <Label htmlFor={`${name}-${value}`}>{label}</Label>
      </Wrapper>
    );
  }
}

export default RadioInput;



// WEBPACK FOOTER //
// ./src/components/form/RadioInput.js